export default "__VITE_ASSET__643da0b6__"